<template>
  <div class="list-scroll">
    <div class="plan-list" v-if="data.length > 1">
      <div
        class="plan-item"
        v-for="(item, index) in data"
        :key="index"
        @click="bindClick(item)"
      >
        <div class="mask" v-if="item.state == 0"></div>
        <div class="title">{{ item.date_month | filterMonth }}月甄选好物券</div>
        <div class="get-time"
          ><span v-if="item.receipt_date"
            >到账时间: {{ item.receipt_date | filterTime }}</span
          ></div
        >
        <div class="time">有效期: {{ item.s_time }}-{{ item.e_time }}</div>
        <div class="btn" v-if="item.state"
          ><span>已到账</span><span class="iconfont icon-you"></span
        ></div>
        <div class="btn btn-disabled" v-else
          ><span>未到账</span><span class="iconfont icon-you"></span
        ></div>
      </div>
    </div>
    <div v-if="data.length == 1">
      <div
        class="plan-item-one"
        v-for="(item, index) in data"
        :key="index"
        @click="bindClick(item)"
      >
        <div class="coupon-name"
          ><span class="coupon-num">8</span><span>元无门槛代金券</span>
        </div>
        <div class="get-time"
          ><span v-if="item.receipt_date"
            >到账时间: {{ item.receipt_date | filterTime }}</span
          ></div
        >
        <div class="time">有效期: {{ item.s_time }}-{{ item.e_time }}</div>
        <div class="btn" v-if="item.state"
          ><span>已到账</span><span class="iconfont icon-you"></span
        ></div>
        <div class="btn btn-disabled" v-else
          ><span>未到账</span><span class="iconfont icon-you"></span
        ></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    filterTime(str) {
      if (!str) {
        return ''
      }
      return str.slice(0, 10).replace(/-/g, '.')
    },
    filterMonth(str) {
      return parseInt(str) || ''
    }
  },
  data() {
    return {}
  },
  methods: {
    bindClick(item) {
      if (item.state == 1) {
        if (this.$http._isApp()) {
          this.$betterwe.onAppPageUrlRoute(
            '/wmOtherPage?fromType=11&url=https://100001525455.retail.n.weimob.com/saas/retail/100001525455/2494001455/market/coupon/index&title=商城'
          )
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.list-scroll {
  padding: 0px 14px;
  overflow-y: scroll;

  .plan-list {
    display: inline-flex;
    align-items: center;

    .plan-item {
      text-align: center;
      position: relative;
      width: 189px;
      height: 114px;
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0a8992e9b6020054d970c40fcec6a703.png');
      background-repeat: no-repeat;
      background-size: contain;
      margin-right: 10px;

      .mask {
        background-color: rgba(255, 255, 255, 0.2);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        z-index: 3;
      }

      .title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #8d5d2e;
        line-height: 20px;
        margin-bottom: 8px;
      }

      .get-time {
        min-height: 14px;
        font-size: 11px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.6);
        line-height: 14px;
        margin-bottom: 2px;
      }

      .time {
        height: 14px;
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: rgba(0, 0, 0, 0.6);
        line-height: 14px;
        margin-bottom: 18px;
      }

      .btn {
        position: absolute;
        left: 50%;
        bottom: 8px;
        transform: translate(-50%, 0%);
        padding: 0px 6px 0px 10px;
        height: 30px;
        background: linear-gradient(90deg, #e2b571 0%, #d09946 100%);
        border-radius: 15px;
        font-size: 14px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 600;
        color: #ffffff;
        line-height: 30px;
        display: inline-flex;
        align-items: center;

        .iconfont {
          margin-left: 2px;
        }
      }

      .btn-disabled {
        background: linear-gradient(90deg, #babbc5 0%, #9fa0a8 100%);
      }
    }

    .plan-item:last-child {
      margin-right: 0;
    }
  }

  .plan-item-one {
    position: relative;
    width: 315px;
    height: 96px;
    padding-top: 17px;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/203cbeeba2680c8f67bdf0123aaaca48.png');
    background-repeat: no-repeat;
    background-size: contain;

    .get-time {
      text-indent: 30px;
      min-height: 14px;
      font-size: 11px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);
      line-height: 14px;
      margin-bottom: 2px;
    }

    .time {
      text-indent: 30px;
      height: 14px;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.6);
      line-height: 14px;
      margin-bottom: 18px;
    }

    .coupon-num {
      font-size: 22px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      color: #8d5d2e;
      line-height: 28px;
      margin-right: 2px;
    }

    .coupon-name {
      text-indent: 30px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #8d5d2e;
      line-height: 24px;
    }

    .btn {
      padding: 0px 6px 0px 10px;
      position: absolute;
      display: flex;
      align-items: center;
      right: 16px;
      top: 50%;
      transform: translate(0%, -50%);
      height: 30px;
      background: linear-gradient(90deg, #e2b571 0%, #d09946 100%);
      border-radius: 15px;
      font-size: 14px;
      font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
      font-weight: 600;
      color: #ffffff;
      line-height: 30px;
    }

    .btn-disabled {
      background: linear-gradient(90deg, #babbc5 0%, #9fa0a8 100%);
    }
  }
}
</style>
